import React from 'react';
import { LuArrowUpDown, LuSearch } from 'react-icons/lu';

import { InputGroup, InputGroupAddon, InputGroupInput } from '@/components/ui/input-group';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

export type LibraryFilterKey = 'all' | 'my-models' | 'my-strategies' | 'claro' | 'blackrock';
export type LibrarySortKey = 'name' | 'accounts';

const FILTER_OPTIONS: Array<{ key: LibraryFilterKey; label: string }> = [
    { key: 'all', label: 'All' },
    { key: 'my-models', label: 'My Models' },
    { key: 'my-strategies', label: 'My Strategies' },
    { key: 'claro', label: 'Claro' },
    { key: 'blackrock', label: 'BlackRock' },
];

interface LibraryFilterBarProps {
    filter: LibraryFilterKey;
    onFilterChange: (filter: LibraryFilterKey) => void;
    counts: Record<LibraryFilterKey, number>;
    showBlackrock: boolean;
    search: string;
    onSearchChange: (search: string) => void;
    sort: LibrarySortKey;
    onSortChange: (sort: LibrarySortKey) => void;
}

export const LibraryFilterBar: React.FC<LibraryFilterBarProps> = ({
    filter,
    onFilterChange,
    counts,
    showBlackrock,
    search,
    onSearchChange,
    sort,
    onSortChange,
}) => {
    return (
        <div className="border-cocoa-100 mb-6 flex flex-wrap items-center justify-between gap-4 border-b pb-3">
            <Tabs value={filter} onValueChange={(value) => onFilterChange(value as LibraryFilterKey)}>
                <TabsList className="h-auto gap-6 border-none px-0">
                    {FILTER_OPTIONS.filter(({ key }) => key !== 'blackrock' || showBlackrock).map(({ key, label }) => (
                        <TabsTrigger
                            key={key}
                            value={key}
                            className="px-0 py-2.5 font-medium data-[state=active]:font-medium"
                        >
                            {label} <span className="text-cocoa-400 ml-1">{counts[key]}</span>
                        </TabsTrigger>
                    ))}
                </TabsList>
            </Tabs>
            <div className="flex items-center gap-2">
                <InputGroup className="border-cocoa-200 h-9 w-60 rounded-full bg-white">
                    <InputGroupAddon align="inline-start">
                        <LuSearch className="text-cocoa-400 h-4 w-4" />
                    </InputGroupAddon>
                    <InputGroupInput
                        value={search}
                        onChange={(e) => onSearchChange(e.target.value)}
                        placeholder="search models and strategies…"
                        className="placeholder:text-cocoa-400 text-[13px] md:text-[13px]"
                    />
                </InputGroup>
                <Select value={sort} onValueChange={(value) => onSortChange(value as LibrarySortKey)}>
                    <SelectTrigger className="border-cocoa-200 h-9 w-[150px] gap-1.5 rounded-lg bg-white text-[13px]">
                        <LuArrowUpDown className="text-cocoa-400 h-3.5 w-3.5" />
                        <SelectValue />
                    </SelectTrigger>
                    <SelectContent className="tracking-[-0.02em]">
                        <SelectItem value="name" className="text-[13px]">
                            Name
                        </SelectItem>
                        <SelectItem value="accounts" className="text-[13px]">
                            Accounts using
                        </SelectItem>
                    </SelectContent>
                </Select>
            </div>
        </div>
    );
};
